import React, { useState, useEffect } from "react";
import {secondsToTime} from "../Helpers/parse";

import "./VideoControls.css"

// This should be stateless
const VideoControls = ({
  playing,
  currentTime=0,
  duration=0,
  volume=1,
  muted=false,
  captions,
  playbackRate,
  secondaryAudioTracks=[],
  currentSAP=-1,
  isLive,
  togglePlaying,
  toggleMuted,
  setVolume,
  seek,
  toggleFullscreen,
  shouldDisplayFullscreen,
  setCaptions,
  setCurrentSAP,
  setPlaybackRate
}) => {

  const [menu, setMenu] = useState("")

  let playLabel = playing ? <i className="fa fa-pause" aria-hidden="true"/> : <i className="fa fa-play" aria-hidden="true"/>
  let muteLabel = muted ? <i className="fa fa-volume-off" aria-hidden="true"/> : <i className="fa fa-volume-up" aria-hidden="true"/>

  let displayedAudioLevel = muted ? 0 : volume

  let menuComponent = ""
  if(menu === "captions") {
    menuComponent = <CaptionsMenu captions={captions} setCaptions={setCaptions}/>
  } else if(menu === "playbackRate") {
    menuComponent = <PlaybackRateMenu playbackRate={playbackRate} setPlaybackRate={setPlaybackRate}/>
  }

  let currentTimeLabel = isLive ? "" : `${secondsToTime(currentTime)} /`
  let durationLabel = isLive ? <span style={{color:"red"}}>LIVE</span> : secondsToTime(duration)

  let containerClass = "video-controls"
  if(shouldDisplayFullscreen || !playing) {
    containerClass += " show-fs"
  }

  let captionsOn = false
  if(captions && captions.length) {
    for(let track of captions) {
      if(track.mode === "showing") {
        captionsOn = true
        break
      }
    }
  }

  return (
    <div id="video-controls" className={containerClass} onBlur={(e) => {if(!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) setMenu("")}}>
      <span><button id="play-pause" type="button" onClick={togglePlaying}>{playLabel}</button></span>
      <span className="video-progress">
        <span id="video-progress-time">{currentTimeLabel} {durationLabel}</span>
        <input type="range" id="progress" min={0} value={currentTime} max={duration} onChange={(e) => {seek(e.currentTarget.value)}}/>
      </span>
      <span>
        <button id="mute" type="button" onClick={toggleMuted}>{muteLabel}</button>
        <input type="range" id="volume" min={0} max={1} value={displayedAudioLevel} step={0.01} onChange={(e) => {setVolume(e.currentTarget.value)}}/>
      </span>
      <span style={{display: captions && captions.length ? "initial" : "none"}}>
        <button id="captions" type="button"
          className={captionsOn ? "" : "off"}
          onClick={() => {
            if(captions.length === 1) {
              if(captionsOn) {
                setCaptions()
              } else {
                setCaptions(captions[0])
              }
            } else {
              if(menu === "captions") setMenu("");
              else setMenu("captions")
            }
          }}
          aria-hidden="true"
        >
          <i className="fas fa-closed-captioning" aria-hidden="true"/>
        </button>
      </span>
      <span style={{display: secondaryAudioTracks.length ? "initial" : "none"}}>
        <button id="fs" type="button" className={currentSAP > -1 ? "" : "off"}
          onClick={() => {
            if(secondaryAudioTracks.length >= 1) {
              if(currentSAP === -1) {
                setCurrentSAP(0)
              } else {
                setCurrentSAP(-1)
              }
            }
          }}
        >
          <i className="fas fa-audio-description" aria-hidden="true"/>
        </button>
      </span>
      <span><button id="playbackrate" type="button" onClick={() => {
        if(menu === "playbackRate") setMenu("");
        else setMenu("playbackRate")
      }}><i className="fa fa-dashboard" aria-hidden="true"/></button></span>
      <span><button id="fs" type="button" onClick={toggleFullscreen}><i className="fa fa-expand" aria-hidden="true"/></button></span>
      {menuComponent}
    </div>
  )
}

const CaptionsMenu = ({
  captions,
  setCaptions
}) => {

  const captionOptions = []
  let isOn = false
  if(captions && captions.length) {
    let labels = {}
    for(let track of captions) {
      if(track.mode === "showing") {
        isOn = true
      }
      if(labels[track.label]) {
        continue
      }
      labels[track.label] = true
      captionOptions.push(<li key={`${track.kind}/${track.language}/${track.label}`} className={track.mode === "showing" ? "selected" : ""} onClick={() => {setCaptions(track)}}>{track.label}</li>)
    }
  }
  captionOptions.unshift(<li key={"_disable"} className={!isOn ? "selected" : ""} onClick={() => {setCaptions()}}>Off</li>)

  return (
    <ul id="caption-list" tabIndex={0}>
      {captionOptions}
    </ul>
  )

}

const PlaybackRateMenu = ({
  playbackRate,
  setPlaybackRate
}) => {

  return (
    <div id="playback-speed-control">
      <div id="psc-title">Playback Speed</div>
      <div id="psc-input-container">
        <div id="psc-input-label">{`${Math.floor(playbackRate * 100) / 100}x`}</div>
        <div id="psc-input">
          <input
            type="range"
            min={0.05}
            max={2}
            step={0.05}
            list="playback-ticks"
            value={playbackRate}
            onChange={(e) => setPlaybackRate(e.currentTarget.value)}
          />
          <datalist id="playback-ticks">
            <option value={0.5} label="0.5x"/>
            <option value={1} label="1x"/>
            <option value={1.5} label="1.5x"/>
            <option value={2} label="2x"/>
          </datalist>
        </div>
      </div>
    </div>
  )

}

export default VideoControls
